import { CredimaxPaymentDetailsModel } from "../Booking/CredimaxPaymentDetailsModel";
export class PaytabsPaymentDetails {

    UnitPrice: string;

    ProductsPerTitle: string;

    Quantity: string;

    Amount: string;

    Title: string;
    AppReqPatientId: string;
    AppointmentRquestNo: string;
    ScreenName: string;
    buttonActivity: string;
    PaymentTypeMode: string;
    Remarks: string;
    RedirectResult: string;
    patientid: string;
	Tap_id:string;
    credimaxPaymentDetails: CredimaxPaymentDetailsModel[] = []; 
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/servicepayment/paytabspaymentdetails.ts